export default "https://statics.cloudfastin.top/static/v1.27.18.3/store/images/c.png?833edf5dc9ed0ee41a7ce73effb9e4c4";